module.exports = __webpack_public_path__ + "static/media/MHRP39N0006.1cc37813.svg";